export default "__VITE_ASSET__DtQc$9NW__"